module.exports = __webpack_public_path__ + "img/HV_cv-perfil-rep.5a21d740.png";